<div class="w-full border-b-[1px] border-neutral-300">
  <div class="header">
    <div class="flex flex-1 items-center gap-3 py-1 ms-4 me-4">
      <div
        class="flex w-0 flex-1 min-w-0 items-center overflow-hidden"
        [class.cursor-pointer]="showHomeLink"
        (click)="onHeaderClick()"
      >
        @if (location?.logoImageUuid) {
          <div
            class="header-logo h-9 md:h-11 w-full max-w-36 md:max-w-44"
            [style.background-image]="'url(' + (location?.logoImageUuid | imageUrl: 'locationLogo') + ')'"
            [attr.aria-label]="location?.businessName"
            role="img"
          ></div>
        } @else {
          <h2 nz-typography class="block min-w-0 w-full overflow-hidden text-ellipsis whitespace-nowrap">
            {{ location?.businessName }}
          </h2>
        }
      </div>
      <div class="shrink-0">
        <app-header-actions></app-header-actions>
      </div>
    </div>
  </div>
</div>
